import { Box, Flex, HStack, ListItem, Text, UnorderedList, VStack } from '@chakra-ui/react'
import { Asterisk, Lightning, Wrench } from '@phosphor-icons/react'
import Card from 'components/Card/Card'
import CardBody from 'components/Card/CardBody'
import CardHeader from 'components/Card/CardHeader'
import dateFormat from 'functions/dateFormat'
import { ReleaseNote } from 'interfaces/releaseNote'

interface Props {
    note: ReleaseNote
}

const ReleaseItem = ({title, icon, items}: any): React.ReactNode => {
    return (
        <Box>
            <HStack spacing={2}>{icon}<Text fontSize="lg" fontWeight="bold">{title}</Text></HStack>
            <UnorderedList pl={8}>
                {
                    items.map((item: any) => <ListItem><Text fontSize="lg">{item.description}</Text></ListItem>)
                }
            </UnorderedList>
        </Box>
    )
}

const ReleaseInfo = ({ note }: Props) => {
    return (
        <Card>
            <CardHeader>{dateFormat(note.date, "dd/MM/yyyy")} - {note.title}</CardHeader>
            <CardBody>
                {/* <VStack alignItems="left" spacing={4}>
                    <Text fontSize="lg" mb={4}>{note.description}</Text>
                    {
                        note.features.length > 0 && <ReleaseItem title="Novas Features" icon={<Asterisk size="22px" weight="duotone" />} items={note.features} />
                    }
                    {
                        note.improvements.length > 0 && <ReleaseItem title="Melhorias" icon={<Lightning size="22px" weight="duotone" />} items={note.improvements} />
                    }
                    {
                        note.fixes.length > 0 && <ReleaseItem title="Ajustes" icon={<Wrench size="22px" weight="duotone" />} items={note.fixes} />
                    }
                </VStack> */}
            </CardBody>
        </Card>
    )
}

export default ReleaseInfo